import React from 'react';
import ImgHowToPay1 from 'src/images/home/how-to-pay/how-to-pay-1.png';
import ImgHowToPay2 from 'src/images/home/how-to-pay/how-to-pay-2.png';
import ImgHowToPay3 from 'src/images/home/how-to-pay/how-to-pay-3.png';
import ImgHowToPay4 from 'src/images/home/how-to-pay/how-to-pay-4.png';
import LinearCTAButton from 'src/components/LinearCTAButton';
import styles from './SectionPayment.module.scss';

const DATA = [
  {
    key: 'how-to-pay-1',
    img: ImgHowToPay1,
    text: 'コンビニ払い',
    to: '/guide#payment-convenience-store',
  },
  {
    key: 'how-to-pay-2',
    img: ImgHowToPay2,
    text: '銀行振込',
    to: '/guide#payment-bank-transfer',
  },
  {
    key: 'how-to-pay-3',
    img: ImgHowToPay3,
    text: '口座振替',
    to: '/guide#payment-account-transfer',
  },
  {
    key: 'how-to-pay-4',
    img: ImgHowToPay4,
    text: 'すぐ払い',
    to: '/guide#payment-paynow',
  },
];

export default function SectionPayment({ data = DATA }) {
  return (
    <section className={styles.section}>
      <h1>支払い方法</h1>
      <h2>ライフスタイルにあわせて</h2>
      <h2>自由に選べる</h2>
      <section className={styles.bodySection} id="how-to-pay">
        <div className={styles.container}>
          {data.map((item, index) => (
            <a
              href={item.to}
              className={styles.item}
              key={item.key}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={item.img}
                alt={`how-to-pay-${index}`}
                className={styles.img}
              />
            </a>
          ))}
        </div>
        <LinearCTAButton
          text="今すぐアプリをダウンロード"
          to="https://paidy.onelink.me/GTiS/WebsiteTPNDPM"
          target="_blank"
          rel="noopener noreferrer"
        />
      </section>
    </section>
  );
}
